// The apiProxy function's HelpKit login hop (functions/src/helpkitAuth.ts).
export const HELPKIT_AUTH_PATH = "/api/v2/token/helpkit";
